import gql from 'graphql-tag';

const vasStepFragments = {
    CheckoutExperienceModel: gql`
        fragment VasStepCheckoutExperienceModel on CheckoutExperienceModel {
            offerGroups {
                ...VasStepOfferGroup
            }
            optionalOfferGroups {
                ...VasStepOfferGroup
                offers {
                    coverageAmount
                    coverageDecimalAmount
                    currency
                    maxCoverageAmount
                    maxCoverageDecimalAmount
                    productVersion
                }
            }
        }
        fragment VasStepOfferGroup on OfferGroup {
            label
            description
            selectionType
            type
            required
            selectedOfferSku
            offers {
                type
                coverageAmount
                description
                sku
                purchaseUntilDate
                links {
                    url
                    label
                }
                label
                amount
                decimalAmount
            }
        }
    `,
};

export default vasStepFragments;
